export default __webpack_public_path__ + "static/N0261-5c4ea0ef364151b090cc568a712c141a.png";